import { Link } from 'react-router-dom';

import { Badge } from '@/components/ui/badge';
import { type StackType } from '@/lib/prompt-lib-utils';
import { cn } from '@/lib/utils';

interface PromptCardProps {
  id: string;
  title: string;
  description: string;
  stackType: StackType;
  className?: string;
  isMobile?: boolean;
}

export function PromptCard({
  id,
  title,
  description,
  stackType,
  className,
  isMobile,
}: PromptCardProps) {
  return (
    <Link
      to={`/dashboard/prompt-library/${id}`}
      className={cn(
        'flex items-start gap-3.5 rounded-lg border border-border bg-muted/50 dark:bg-white/[0.03]',
        'hover:border-primary/30 transition-colors',
        'cursor-pointer',
        isMobile ? 'p-3.5' : 'p-4',
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-sm text-foreground mb-1">{title}</h3>
        <p className="text-xs text-muted-foreground line-clamp-2 leading-relaxed">{description}</p>
      </div>
      <span className={cn(
        'shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium mt-0.5',
        stackType === 'fullstack'
          ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
          : 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
      )}>
        {stackType === 'fullstack' ? 'Fullstack' : 'Frontend'}
      </span>
    </Link>
  );
}
